import {
    useEffect,
    useState
} from "react";
import {
    Image,
    View
} from "react-native";
import type SmartCoverImageProps from "./type";
import stylesheet from "./stylesheet";

const SmartCoverImage = ({
    verticalCropTolerance = 0.03,
    cropThreshold = 0.08,
    blurRadius = 15,
    containerStyle,
    imageStyle,
    url
}: SmartCoverImageProps) => {
    const [
        shouldBlur,
        setShouldBlur
    ] = useState<boolean>(false);

    const [
        containerRatio,
        setContainerRatio
    ] = useState<number>(1);

    useEffect(() => {
        if(!url) {
            return;
        }

        Image.getSize(url, (width, height) => {
            if(!width || !height) {
                return;
            }

            const imageRatio = width / height;

            if(imageRatio < containerRatio) {
                const verticalCrop = 1 - (imageRatio / containerRatio);
                if(verticalCrop > verticalCropTolerance) {
                    setShouldBlur(true);
                    return;
                }
            } else {
                const horizontalCrop = 1 - (containerRatio / imageRatio);
                if(horizontalCrop > cropThreshold) {
                    setShouldBlur(true);
                    return;
                }
            }

            setShouldBlur(false);
        }, () => {
            setShouldBlur(false);
        });
    }, [
        verticalCropTolerance,
        containerRatio,
        cropThreshold,
        url
    ]);

    return <View
        onLayout={(event) => {
            const {
                height,
                width
            } = event.nativeEvent.layout;
            if(width && height) {
                setContainerRatio(width / height);
            }
        }}
        style={[
            stylesheet.container,
            containerStyle
        ]}
    >
        {shouldBlur && <Image
            style={[
                stylesheet.backgroundImage,
                imageStyle
            ]}
            blurRadius={blurRadius}
            resizeMode="cover"
            source={{
                uri: url
            }}
        />}
        <Image
            resizeMode={shouldBlur ? "contain" : "cover"}
            style={[
                stylesheet.image,
                imageStyle
            ]}
            source={{
                uri: url
            }}
        />
    </View>;
};

export default SmartCoverImage;
